// extracted by mini-css-extract-plugin
module.exports = {"saperator":"Socials_saperator__10c4b","iconPadding":"Socials_iconPadding__1ezxY","normalFontFamily":"Socials_normalFontFamily__uEtGi","socialsText":"Socials_socialsText__1rtUU"};